import { render } from "./NoSearchResults.vue?vue&type=template&id=280f02c0"
import script from "./NoSearchResults.vue?vue&type=script&lang=js"
export * from "./NoSearchResults.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__